<template>
  <div id="faq">
    <h2>{{ $t("message.faq.title") }}</h2>
    <hr>
    <VueFaqAccordion
      :items="myItems"
      font-color="#404b69"
      border-color="#404b69"
    />
  </div>
</template>

<script>
import VueFaqAccordion from 'vue-faq-accordion'

export default {
  name: 'Faq',
  components: {
    VueFaqAccordion
  },
  data () {
    return {
      myItems: [
        {
          title: this.$i18n.t('message.faq.1.title'),
          value: this.$i18n.t('message.faq.1.value'),
          category: this.$i18n.t('message.faq.category[0]')
        },
        {
          title: this.$i18n.t('message.faq.2.title'),
          value: this.$i18n.t('message.faq.2.value'),
          category: this.$i18n.t('message.faq.category[0]')
        },
        {
          title: this.$i18n.t('message.faq.3.title'),
          value: this.$i18n.t('message.faq.3.value'),
          category: this.$i18n.t('message.faq.category[0]')
        },
        {
          title: this.$i18n.t('message.faq.4.title'),
          value: this.$i18n.t('message.faq.4.value'),
          category: this.$i18n.t('message.faq.category[1]')
        },
        {
          title: this.$i18n.t('message.faq.5.title'),
          value: this.$i18n.t('message.faq.5.value'),
          category: this.$i18n.t('message.faq.category[1]')
        },
        {
          title: this.$i18n.t('message.faq.6.title'),
          value: '<img src="https://files-uploader.xzy.pw/static/euploader.svg">',
          category: this.$i18n.t('message.faq.category[2]')
        }
      ]
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Faq.vue